export default __webpack_public_path__ + "static/media/training.422b23d1.jpg";